<template>
  <SeoPage page-key="posizionamentoGoogleMendrisio" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'PosizionamentoGoogleMendrisioPage'
})
</script>

